<template>
    <button @click="toggle" :class="classes" :disabled='disabled'>
      <slot name="default" />
    </button>
  
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    toggle() {
      this.$emit("click");
    }
  },
  computed: {
    classes() {
      if (this.disabled) {
        return ['pbc-tab-button-disabled', 'pbc-tab-button']
      } else {
        const classes =['pbc-tab-button'];
        if (this.value) {
          classes.push('pbc-tab-button-on');
        } else {
          classes.push('pbc-tab-button-off');
        }
        return classes;
      }
    }
  },
  watch:{
  }
  
}
</script>
